import type { OptionsVisibility } from '@atlassian/ui-modifications-core/types';
import { FieldValueLookupError } from '@atlassian/ui-modifications-core/utils';
import type { SelectPublicGetValue } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/fields/select.tsx';
import { applyOptionsVisibilityRule } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/apply-options-visibility-rule/index.tsx';
import { getAvailableOptionsVisibilityRule } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/get-available-options-visibility-rule/index.tsx';
import { singleValueLookup } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/single-value-lookup/index.tsx';
import type { SelectPublicSetValue } from '@atlassian/ui-modifications-public-api-utils/field/select';

export type SelectInternalAllowedValue = {
	id: string;
	value: string;
};

export type SelectInternalValue = null | {
	label: string;
	value: string;
};

export const transformSelectSetOptionsVisibility = (
	optionsVisibility: OptionsVisibility,
	lookupValues: SelectInternalAllowedValue[],
): SelectInternalAllowedValue[] =>
	applyOptionsVisibilityRule(optionsVisibility, lookupValues, 'id');

export const transformSelectGetOptionsVisibility = (
	optionsVisibility: OptionsVisibility,
	lookupValues: SelectInternalAllowedValue[],
): OptionsVisibility => getAvailableOptionsVisibilityRule(optionsVisibility, lookupValues, 'id');

export const selectSetValueTransformer = (
	value: SelectPublicSetValue,
	allowedValues?: SelectInternalAllowedValue[],
): SelectInternalValue => {
	if (value === null) {
		return null;
	}

	const foundValue = singleValueLookup<SelectInternalAllowedValue>(value, allowedValues, 'id');

	if (!foundValue) {
		throw new FieldValueLookupError();
	}

	return { value: foundValue.id, label: foundValue.value };
};

export const selectGetValueTransformer = (value: SelectInternalValue): SelectPublicGetValue => {
	if (!value) {
		return null;
	}

	const { label, value: id } = value;

	return { id, value: label };
};
